import { LoadIdView } from '../../../../models';

export class ShipmentLoadStatusChainLoad {
  public static readonly type = '[ShipmentLoadStatusChain] Load Status Chain';
  constructor(public payload: LoadIdView) {}
}

export class ShipmentLoadStatusChainSetInitialState {
  public static readonly type = '[ShipmentLoadStatusChain] Set Initial State';
}
